import React from 'react';
import PropTypes from 'prop-types';

import { StyledLoader } from './styled';

const SkeletonLoader = ({
  fullWidth = true,
  height = '100%',
  w,
  as,
  mobileW,
}) => {
  return (
    <StyledLoader
      as={as}
      fullWidth={fullWidth}
      height={height}
      w={w}
      mobileW={mobileW}
    />
  );
};

SkeletonLoader.propTypes = {
  fullWidth: PropTypes.bool,
  height: PropTypes.string,
  w: PropTypes.string,
};

export default SkeletonLoader;
